export default __webpack_public_path__ + "static/media/cnn_kr_jing_b3.4ddd62e8.mp3";